import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_CONSTANTS } from '../../base/api-constants';
import { BaseService } from '../../base/base-service';



@Injectable({
  providedIn: 'root'
})
export class AdsService extends BaseService {

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  GetAds(status: any): Observable<any> {
    return this.get(API_CONSTANTS.Ads.GetAds + status);
  }

  ChangeAdStatus(id: any): Observable<any> {
    return this.get(API_CONSTANTS.Ads.ChangeAdStatus + id);
  }

  CreateAd(model: any): Observable<any> {
    return this.post_formData(API_CONSTANTS.Ads.CreateAd, model);
  }

  AddLinkToAd(model: any): Observable<any> {
    return this.post(API_CONSTANTS.Ads.AddLinkToAd, model);
  }

  DeleteAd(id: any): Observable<any> {
    return this.get(API_CONSTANTS.Ads.DeleteAd + id);
  }
}
